import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Catalogue } from "../base";

export const ContactInformation = types
  .model({
    id: "",
    fullName: types.maybeNull(types.string),
    phoneNumber: types.maybeNull(types.string),
    email: types.maybeNull(types.string),
    departmentTypeId: types.maybeNull(types.string),
    customerId: types.maybeNull(types.string),
    departmentType: types.maybeNull(Catalogue),
  })
  .actions(withSetPropAction);
export interface IContactInformation
  extends Instance<typeof ContactInformation> {}
export interface IContactInformationProperties
  extends SnapshotIn<typeof ContactInformation> {}
